export default {
  index: [
    {
      path: '/zkpartnerranking',
      component: resolve => require(['./zkpartnerrankingrewardIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpartner_ranking_reward/_router.js